export const CONVERT_FILE_RESET_STATE = 'CONVERT_FILE_RESET_STATE';
export const CONVERT_FILE_CURRENT_ITEM = 'CONVERT_FILE_CURRENT_ITEM';

export const CONVERT_FILE_REQUEST_LOADING = 'CONVERT_FILE_REQUEST_LOADING';
export const CONVERT_FILE_REQUEST_SUCCESS = 'CONVERT_FILE_REQUEST_SUCCESS';
export const CONVERT_FILE_REQUEST_FAILED = 'CONVERT_FILE_REQUEST_FAILED';

export const CONVERT_FILE_CURRENT_ACTION = 'CONVERT_FILE_CURRENT_ACTION';
export const CONVERT_FILE_RESET_ACTION = 'CONVERT_FILE_RESET_ACTION';